import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface Subject {
  id: string;
  name: string;
  icon: LucideIcon;
  color: string;
}

interface SubjectSelectorProps {
  subjects: Subject[];
  selectedSubject: string;
  onSelectSubject: (subjectId: string) => void;
  disabled?: boolean;
}

export function SubjectSelector({
  subjects,
  selectedSubject,
  onSelectSubject,
  disabled = false
}: SubjectSelectorProps) {
  return (
    <fieldset>
      <legend className="block text-sm font-semibold text-gray-700 mb-3">Choose Subject</legend>
      <div className="grid grid-cols-3 gap-3" role="radiogroup" aria-labelledby="subject-selection">
        {subjects.map((subject) => (
          <button
            key={subject.id}
            onClick={() => onSelectSubject(subject.id)}
            disabled={disabled}
            role="radio"
            aria-checked={selectedSubject === subject.id}
            aria-label={`Select ${subject.name} subject`}
            className={`flex flex-col items-center p-4 rounded-xl border-2 transition-all ${
              selectedSubject === subject.id
                ? `border-${subject.color}-500 bg-${subject.color}-50`
                : 'border-gray-200 hover:border-gray-300'
            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <subject.icon className={`w-8 h-8 mb-2 ${
              selectedSubject === subject.id ? `text-${subject.color}-600` : 'text-gray-400'
            }`} />
            <span className={`font-medium ${
              selectedSubject === subject.id ? `text-${subject.color}-700` : 'text-gray-600'
            }`}>
              {subject.name}
            </span>
          </button>
        ))}
      </div>
    </fieldset>
  );
}
